import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useAreasVendaVendedor from "./useAreasVendaVendedor";

const useEquipeVenda = (formikRef, editFormSelect = false, opt = {} ) => {
  const equipeSelect = useSelect("equipeVenda");

  const [equipe, setEquipe] = useState(0);
  const [fila, setFila] = useState(null);
  const [equipes, setEquipes] = useState([]);
  const [areas, setAreas] = useState([]);
  const [equipeEdit, setEquipeEdit] = useState(null);

  const { equipesIds } = useAreasVendaVendedor(formikRef);

  useEffect(() => {
    const fetchEquipes = async () => {
      const equipesArray = [];
      await db.equipesVenda.each((eq) => {
        equipesArray.push(eq);
      });
      setEquipes(equipesArray);
    };
    fetchEquipes();
  }, []);

  useEffect(() => {
    const fetchAreas = async () => {
      const areasArray = [];
      await db.areasVendaVendedor.each((a) => {
        areasArray.push(a);
      });
      setAreas(areasArray);
    };
    fetchAreas();
  }, []);

  const equipesFiltradas = useMemo(() => {
    if (!equipesIds?.length) return [];

    return equipes
      .filter((eq) => equipesIds.includes(eq.id))
      .map((eq) => {
        const area = areas.find((a) => a.equipeVendaId === eq.id);
        return {
          ...eq,
          escritorioVendaId: area ? area.escritorioVendaId : null,
        };
      });
  }, [equipes, equipesIds, areas]);

  const optionsEquipe = useMemo(
    () => prepareForOptions(equipesFiltradas, ["nome"], "id", "escritorioVendaId"),
    [equipesFiltradas]
  );

  const equipesObjId = useMemo(
    () => createEquipeObj({ key: "id", data: equipesFiltradas, prefix: "key-" }),
    [equipesFiltradas]
  );
  const equipesObjCodigo = useMemo(
    () => createEquipeObj({ key: "codigo", data: equipesFiltradas }),
    [equipesFiltradas]
  );
  const equipesObjNome = useMemo(() => createEquipeObj({ key: "nome", data: equipesFiltradas }), [equipesFiltradas]);

  function createEquipeObj({ key = "codigo", data = [], prefix = "" }) {
    if (Array.isArray(data)) {
      return data.reduce((acc, cur) => {
        acc[`${prefix}${cur[key]}`] = cur;
        return acc;
      }, {});
    }
    return {};
  }

  useEffect(() => {
    if (fila && optionsEquipe?.length > 0) {
      SetSelectEquipe(fila);
    }
  }, [optionsEquipe, fila]);

  function onChangeEquipe(e) {
    equipeSelect.upDateValue(e.value);
    equipeSelect.upDateDefaultValue(e || "");
    formikRef?.current?.setFieldValue("equipeVendaId", e.value);

    setTimeout(() => formikRef?.current?.setFieldTouched("equipeVendaId", true));
    setEquipe(e.value);
  }

  function SetSelectEquipe(id) {
    if (optionsEquipe?.length > 0) {
      const equipe = optionsEquipe.find((eq) => eq.value === id);
      if (equipe) onChangeEquipe(equipe);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (optionsEquipe.length === 1) {
      SetSelectEquipe(optionsEquipe[0].value);
    }
  }, [optionsEquipe]);

  function clearEquipe() {
    equipeSelect.upDateValue(null);
    equipeSelect.upDateDefaultValue(null);

    formikRef?.current?.setFieldValue("equipeVendaId", null);
    formikRef?.current?.setFieldTouched("equipeVendaId", false);

    setEquipe(0);
    setFila(null);
  }


  useEffect(() => {
    if (editFormSelect && opt) {
      const { equipeVendaId } = opt || {};
      if (equipeVendaId && equipeVendaId !== 0) {
        const fetchEquipe = async () => {
          const result = await db.equipesVenda
            .where("id")
            .equals(equipeVendaId)
            .first();

          setEquipeEdit(result ? [result] : null);
        };

        fetchEquipe();
      } else {
        setEquipeEdit(null);
      }
    }
  }, [editFormSelect, opt]);


  const optionsEquipeedit = useMemo(
    () => equipeEdit?.length > 0 ? prepareForOptions(equipeEdit, ["nome"], "id") : null,
    [equipeEdit]
  );


    useEffect(() => {
  if (editFormSelect && optionsEquipeedit?.length === 1) {
    const eqp = optionsEquipeedit[0];
    if (eqp) {
      onChangeEquipe(eqp);
    }
  }
}, [editFormSelect, optionsEquipeedit]);

  return {
    optionsEquipe,
    equipes: equipesFiltradas,
    clearEquipe,
    onChangeEquipe,
    SetSelectEquipe,
    equipe,
    equipeSelect,
    equipesObjId,
    equipesObjCodigo,
    equipesObjNome,
    optionsEquipeedit,
  };
};

export default useEquipeVenda;
